var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"wave-container",class:[_vm.position]},[_c('svg',{staticClass:"wave",attrs:{"width":"100%","height":"100%","version":"1.1","xmlns":"http://www.w3.org/2000/svg","id":"intro"}},[_c('path',{ref:"wave",attrs:{"transform":"translate(0,10)","d":"","fill":_vm.color}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }